import { NavLink, useNavigate } from "react-router-dom";
import { company } from "@/data/fixtures";
import BrandMark from "@/components/BrandMark";
import UserMenu from "@/components/UserMenu";

const NavItem = ({ to, label, testId }) => (
  <NavLink
    to={to}
    end={to === "/"}
    data-testid={testId}
    className={({ isActive }) =>
      [
        "px-3 py-2 text-[13px] font-medium transition-colors border-b-2 -mb-px whitespace-nowrap",
        isActive
          ? "border-[color:var(--mos-accent)] text-[color:var(--mos-text)]"
          : "border-transparent text-slate-500 hover:text-slate-800",
      ].join(" ")
    }
  >
    {label}
  </NavLink>
);

export default function TopBar() {
  const navigate = useNavigate();
  return (
    <header
      className="border-b sticky top-0 z-30"
      style={{ background: "var(--mos-surface)", borderColor: "var(--mos-border)" }}
      data-testid="top-bar"
    >
      <div className="max-w-[1240px] mx-auto px-8 h-14 flex items-center gap-6">
        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-2.5 group flex-none"
          data-testid="brand-home"
          aria-label="ManufacturingOS home"
        >
          <BrandMark size={22} variant="default" data-testid="brand-mark" />
          <span className="flex items-baseline gap-2">
            <span
              className="text-[15px] font-semibold whitespace-nowrap tracking-[-0.005em]"
              style={{ color: "var(--mos-accent)" }}
              data-testid="brand-wordmark"
            >
              Manufacturing<span
                className="mos-mono font-medium"
                style={{ color: "#64748B" }}
              >OS</span>
            </span>
            <span className="text-[12.5px] text-slate-500 font-normal whitespace-nowrap">
              · {company.name}
            </span>
          </span>
        </button>

        <nav className="flex items-center gap-1 h-full ml-2">
          <NavItem to="/" label="Daily Briefing" testId="nav-daily-briefing" />
          <NavItem to="/risk" label="Commitment Risk" testId="nav-commitment-risk" />
          <NavItem to="/quality" label="Quality" testId="nav-quality" />
          <NavItem to="/suppliers" label="Suppliers" testId="nav-suppliers" />
          <NavItem to="/assets" label="Assets" testId="nav-assets" />
          <NavItem to="/genealogy" label="Genealogy" testId="nav-genealogy" />
        </nav>

        <div className="ml-auto flex items-center gap-4">
          <NavLink
            to="/audit"
            data-testid="nav-audit-log"
            className={({ isActive }) =>
              [
                "text-[12.5px] font-normal underline-offset-4 hover:underline whitespace-nowrap",
                isActive
                  ? "text-[color:var(--mos-accent)] underline"
                  : "text-slate-500 hover:text-slate-800",
              ].join(" ")
            }
          >
            Audit Log
          </NavLink>
          <div
            className="h-6 w-px"
            style={{ background: "var(--mos-border)" }}
          />
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
